var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoScroll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    color: "inherit",
    fontSize: "inherit",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7 2.44a2 2 0 0 1 2.63 0l19.63 17.05A2 2 0 0 1 43.65 23H33a1 1 0 0 0-1 1v6a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2v-6a1 1 0 0 0-1-1H4.36a2 2 0 0 1-1.31-3.51L22.7 2.44ZM9.24 19H18a2 2 0 0 1 2 2v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6c0-1.1.9-2 2-2h8.37L24.62 7.25a1 1 0 0 0-1.29 0L9.23 19ZM16 36a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H17a1 1 0 0 1-1-1v-2ZM17 42a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoScroll);
export default __webpack_public_path__ + "static/media/auto-scroll.b68c4bcd7d6be1b07240871cfa1c1d28.svg";
export { ForwardRef as ReactComponent };